import {Injectable} from '@angular/core';
import {forkJoin, map, Observable, of} from 'rxjs';
import {CatalogMembershipRequest} from '../models/clare';
import {CatalogMembershipApiService} from './catalog-membership-api.service';

export interface Catalogable {
  type: 'product' | 'bundle';
  id: number;
}

export interface CatalogMembershipSyncRequest {
  catalogable: Catalogable;
  currentCatalogIds: number[];
  selectedCatalogIds: number[];
}

export interface CatalogMembershipSyncResult {
  selectedCatalogIds: number[];
  catalogIdsToAssign: number[];
  catalogIdsToRemove: number[];
}

@Injectable({providedIn: 'root'})
export class CatalogMembershipSyncService {
  constructor(private catalogMembershipApi: CatalogMembershipApiService) {}

  sync(request: CatalogMembershipSyncRequest): Observable<CatalogMembershipSyncResult> {
    const selectedCatalogIds = [...new Set(request.selectedCatalogIds)];
    const currentCatalogIds = [...new Set(request.currentCatalogIds)];
    const currentCatalogIdSet = new Set(currentCatalogIds);
    const selectedCatalogIdSet = new Set(selectedCatalogIds);
    const catalogIdsToAssign = selectedCatalogIds.filter(catalogId => !currentCatalogIdSet.has(catalogId));
    const catalogIdsToRemove = currentCatalogIds.filter(catalogId => !selectedCatalogIdSet.has(catalogId));
    const result = {selectedCatalogIds, catalogIdsToAssign, catalogIdsToRemove};

    if (!catalogIdsToAssign.length && !catalogIdsToRemove.length) {
      return of(result);
    }

    return forkJoin([
      ...catalogIdsToAssign.map(catalogId =>
        this.catalogMembershipApi.assign(this.membershipRequest(catalogId, request.catalogable))
      ),
      ...catalogIdsToRemove.map(catalogId =>
        this.catalogMembershipApi.remove(this.membershipRequest(catalogId, request.catalogable))
      ),
    ]).pipe(map(() => result));
  }

  private membershipRequest(catalogId: number, catalogable: Catalogable): CatalogMembershipRequest {
    return catalogable.type === 'product'
      ? {catalog_id: catalogId, product_ids: [catalogable.id]}
      : {catalog_id: catalogId, bundle_ids: [catalogable.id]};
  }
}
